import { SubscriptionBenefit } from '../../types/Subscription';

const FREE_BENEFITS: SubscriptionBenefit[] = [
    {
        text: 'SelectSubscription:free_plan:benefits:unlimited_contacts_horses:text',
    },
    {
        text: 'SelectSubscription:free_plan:benefits:unlimited_usage:text',
    },
    {
        prefix: 'SelectSubscription:free_plan:benefits:inventory_management:prefix',
        text: 'SelectSubscription:free_plan:benefits:inventory_management:text',
    },
    {
        prefix: 'SelectSubscription:free_plan:benefits:scheduling_tools:prefix',
        text: 'SelectSubscription:free_plan:benefits:scheduling_tools:text',
    },
    {
        prefix: 'SelectSubscription:free_plan:benefits:equinet_invoicing:prefix',
        text: 'SelectSubscription:free_plan:benefits:equinet_invoicing:text',
    },
    {
        prefix: 'SelectSubscription:free_plan:benefits:convenient_access:prefix',
        text: 'SelectSubscription:free_plan:benefits:convenient_access:text',
    },
];

const PERSONAL_BENEFITS: SubscriptionBenefit[] = [
    {
        prefix: 'SelectSubscription:premium_plan:personal_benefits:invoicing_unlimited:prefix',
        text: 'SelectSubscription:premium_plan:personal_benefits:invoicing_unlimited:text',
    },
    {
        prefix: 'SelectSubscription:premium_plan:personal_benefits:appointment_invitations:prefix',
        text: 'SelectSubscription:premium_plan:personal_benefits:appointment_invitations:text',
    },
    {
        prefix: 'SelectSubscription:premium_plan:personal_benefits:rsvp:prefix',
        text: 'SelectSubscription:premium_plan:personal_benefits:rsvp:text',
    },
    {
        prefix: 'SelectSubscription:premium_plan:personal_benefits:client_reminders:prefix',
        text: 'SelectSubscription:premium_plan:personal_benefits:client_reminders:text',
    },
    {
        prefix: 'SelectSubscription:premium_plan:personal_benefits:onboarding_support:prefix',
        text: 'SelectSubscription:premium_plan:personal_benefits:onboarding_support:text',
    },
    {
        prefix: 'SelectSubscription:premium_plan:personal_benefits:zero_commitment:prefix',
        text: 'SelectSubscription:premium_plan:personal_benefits:zero_commitment:text',
    },
];

const TEAM_BENEFITS: SubscriptionBenefit[] = [
    {
        prefix: 'SelectSubscription:premium_plan:team_benefits:team_collaboration:prefix',
        text: 'SelectSubscription:premium_plan:team_benefits:team_collaboration:text',
    },
    {
        prefix: 'SelectSubscription:premium_plan:team_benefits:information_sharing:prefix',
        text: 'SelectSubscription:premium_plan:team_benefits:information_sharing:text',
    },
    {
        prefix: 'SelectSubscription:premium_plan:team_benefits:members_limit:prefix',
        text: 'SelectSubscription:premium_plan:team_benefits:members_limit:text',
    },
    {
        prefix: 'SelectSubscription:premium_plan:team_benefits:zero_commitment:prefix',
        text: 'SelectSubscription:premium_plan:team_benefits:zero_commitment:text',
    },
];

export { FREE_BENEFITS, PERSONAL_BENEFITS, TEAM_BENEFITS };
